__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "billing-application";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("axios", "0.27.2", function() { return __webpack_require__.e(7305).then(function() { return function() { return __webpack_require__(7305); }; }); });
			register("jwt-decode", "3.1.2", function() { return __webpack_require__.e(414).then(function() { return function() { return __webpack_require__(414); }; }); });
			register("validator", "13.9.0", function() { return __webpack_require__.e(5212).then(function() { return function() { return __webpack_require__(5212); }; }); });
			register("vue-prism-editor", "1.3.0", function() { return __webpack_require__.e(6586).then(function() { return function() { return __webpack_require__(6586); }; }); });
			register("vue-router", "3.6.5", function() { return __webpack_require__.e(937).then(function() { return function() { return __webpack_require__(937); }; }); });
			register("vue", "2.7.14", function() { return __webpack_require__.e(6857).then(function() { return function() { return __webpack_require__(6857); }; }); });
			register("vuex", "3.6.2", function() { return __webpack_require__.e(9873).then(function() { return function() { return __webpack_require__(9873); }; }); });
			initExternal(9967);
			initExternal(7414);
			initExternal(1040);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};